// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"268":"542616d7","453":"cd20d85b","455":"9aebbc18","524":"e486b1e8","704":"d17e4ca8","943":"13fed250"}[chunkId] + ".chunk.css";
};